<div [formGroup]="materialRowForm">
    <div class="material-cost-rows" formGroupName="headerRow">
        <button mat-icon-button (click)="isMaterialExpanded = !isMaterialExpanded" class="button-expand-collapse">
            <mat-icon class="icon-expand-collapse">
                {{isMaterialExpanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <table class="full-width">
            <tr class="custom-table-row">
                <td class="material-cost-row-name">{{ sectionLabel | translate}}&nbsp;<span *ngIf="isSubsidyValuePresent" class="subsidy-applied">({{ 'SUBSIDY_APPLIED' | translate }})</span></td>
                <td class="estimate-table-column width-110">
                    {{ headerRowFormGroup.controls.cost.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-70">
                    {{ headerRowFormGroup.controls.escalate.value }}
                    @if(headerRowFormGroup.controls.escalate.value) {
                    <span (click)="openEscalationDialog(sectionLabel)" class="custom-anchor"
                        [class.collab-sapsub-disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted">
                        <img class="escalation-icon" src="assets/images/Escalation.JPG" alt="Escalation Image Icon">
                    </span>
                }
                </td>
                <td class="estimate-table-column width-70">
                    {{ headerRowFormGroup.controls.tdcPercentage.value | decimalPrecision }}%
                </td>
                <td class="estimate-table-column width-70">
                    <ng-container *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else materialRowFormNotLabor">
                        <ng-container *ngIf="this.isMarkUpSelected; else materialRowFormNotMarkUp">
                            <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.headerRow]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="markUpPercentage"
                                    class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #materialRowFormNotMarkUp>
                            <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.headerRow]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal"
                                    formControlName="grossMarginPercentage" class="input-alignment" />
                            </mat-form-field>
                        </ng-template>
                    </ng-container>
                    <ng-template #materialRowFormNotLabor>
                        <ng-container *ngIf="this.isMarkUpSelected; else materialRowFormNotMarkUp">
                            {{ headerRowFormGroup.controls.markUpPercentage.value | decimalPrecision }}%
                        </ng-container>
                        <ng-template #materialRowFormNotMarkUp>
                            {{ headerRowFormGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                        </ng-template>
                    </ng-template>
                </td>
                <td class="estimate-table-column width-210 padding-gm">
                    {{ headerRowFormGroup.controls.grossMargin.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-110">
                    <ng-container
                        *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else materialRowFormNoInputSellPrice">
                        <mat-form-field appearance="outline" class="mat-input-alignment width-110" [class.sell-price-changed]="estimateTab?.[sellPriceFlags.headerRow]">
                            <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig" [showStepper]="false" inputmode="decimal" formControlName="sellPrice" class="input-alignment" />
                        </mat-form-field>
                    </ng-container>
                    <ng-template #materialRowFormNoInputSellPrice>
                        {{ headerRowFormGroup.controls.sellPrice.value | multilingualCurrency }}
                    </ng-template>
                </td>
            </tr>
        </table>
    </div>
    <div *ngIf="isMaterialExpanded" class="material-cost-row-expandable">

        <div class="table-container">
            <table class="full-width">
                <tr class="material-cost-child-rows margin-bottom-2" formGroupName="shippingAndHandling">
                    <td class="custom-anchor shipping-warranty-anchor" [class.collab-sapsub-disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted || isEstimateClosed"
                        (click)="openShippingAndHandlingDialog()">{{
                        'SHIPPING_AND_HANDLING' | translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ shippingAndHandlingFormGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ shippingAndHandlingFormGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container
                            *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else materialRowFormShippingandHandlingNotLabor">
                            <ng-container
                                *ngIf="this.isMarkUpSelected; else materialRowFormShippingandHandlingNotMarkUpInput">
                                <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.shippingAndHandling]">
                                    <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="markUpPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-container>
                            <ng-template #materialRowFormShippingandHandlingNotMarkUpInput>
                                <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.shippingAndHandling]">
                                    <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal"
                                        formControlName="grossMarginPercentage" class="input-alignment" />
                                </mat-form-field>
                            </ng-template>
                        </ng-container>
                        <ng-template #materialRowFormShippingandHandlingNotLabor>
                            <ng-container
                                *ngIf="this.isMarkUpSelected; else materialRowFormShippingandHandlingNotMarkUp">
                                {{ headerRowFormGroup.controls.markUpPercentage.value | decimalPrecision }}%
                            </ng-container>
                            <ng-template #materialRowFormShippingandHandlingNotMarkUp>
                                {{ headerRowFormGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                            </ng-template>
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ shippingAndHandlingFormGroup.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        <ng-container *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else noInputSellPrice">
                            <mat-form-field appearance="outline" class="mat-input-alignment width-110" [class.sell-price-changed]="estimateTab?.[sellPriceFlags.shippingAndHandling]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig" [showStepper]="false" inputmode="decimal" formControlName="sellPrice" class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #noInputSellPrice>
                            {{ shippingAndHandlingFormGroup.controls.sellPrice.value | multilingualCurrency }}
                        </ng-template>
                    </td>
                </tr>
                <tr class="material-cost-child-rows" formGroupName="warranty">
                    <td class="custom-anchor shipping-warranty-anchor" [class.collab-sapsub-disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted || isEstimateClosed"
                        (click)="openWarrantyDialog()">{{ 'WARRANTY' |
                        translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ warrantyFormGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ warrantyFormGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container
                            *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else materialRowFormWarrantyLaborNotLabor">
                            <ng-container *ngIf="this.isMarkUpSelected; else materialRowFormWarrantyNotMarkUp">
                                <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.warranty]">
                                    <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="markUpPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-container>
                            <ng-template #materialRowFormWarrantyNotMarkUp>
                                <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlags.warranty]">
                                    <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal"
                                        formControlName="grossMarginPercentage" class="input-alignment" />
                                </mat-form-field>
                            </ng-template>
                        </ng-container>
                        <ng-template #materialRowFormWarrantyLaborNotLabor>
                            <ng-container *ngIf="this.isMarkUpSelected; else materialRowFormWarrantyNotMarkUp">
                                {{ warrantyFormGroup.controls.markUpPercentage.value | decimalPrecision }}%
                            </ng-container>
                            <ng-template #materialRowFormWarrantyNotMarkUp>
                                {{ warrantyFormGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                            </ng-template>
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ warrantyFormGroup.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        <ng-container
                            *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else materialRowFormWarrantyNoInputSellPrice">
                            <mat-form-field appearance="outline" class="mat-input-alignment width-110" [class.sell-price-changed]="estimateTab?.[sellPriceFlags.warranty]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig" [showStepper]="false" inputmode="decimal" formControlName="sellPrice" class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #materialRowFormWarrantyNoInputSellPrice>
                            {{ warrantyFormGroup.controls.sellPrice.value | multilingualCurrency }}
                        </ng-template>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>